<template>
  <main-layout>
    <modal-send-status title="Envoie" :sending-status="status"></modal-send-status>
    <b-form class="p-4" @submit.stop.prevent @submit="Submit">
      <b-form-group label="Titre">
        <b-form-input v-model="titre"></b-form-input>
      </b-form-group>
      <b-form-group label="Debut de la campagne">
        <b-form-datepicker v-model="start_at" required></b-form-datepicker>
      </b-form-group>
      <b-form-group label="Video">
        <b-form-input v-model="video"></b-form-input>
      </b-form-group>
      <b-form-group label="exercices">
        <b-form-select
            v-model="exercices"
            :options="options"
            multiple :select-size="10">
        </b-form-select>
      </b-form-group>
      <back-btn-toolbar>
        <b-btn variant="primary" type="submit">SAUVER</b-btn>
      </back-btn-toolbar>
    </b-form>
  </main-layout>
</template>

<script>
import {Produit} from "@/js/caller";
import BackBtnToolbar from "@/components/back-btn-toolbar";
import ModalSendStatus from "@/components/Modals/modalSendStatus";

export default {
  name      : "ContenuPrincipalVue",
  components: {ModalSendStatus, BackBtnToolbar},
  data() {
    return {
      id       : null,
      titre    : "",
      start_at : null,
      video    : "",
      exercices: [],
      options  : [],
      status   : 0,
    }
  },
  methods: {
    Submit() {
      const self = this;
      const {id, titre, start_at, video, exercices} = self;
      const finish = (status, id) => {
        self.status = status
        setTimeout(() => {
          this.$bvModal.hide("sendingLoadingScreen");
          if (id) this.$router.replace({name: "ContenuPrincipalVue", params: {id}})
        }, 2000)
      }
      self.$bvModal.show("sendingLoadingScreen")
      Produit.SaveCP({id, titre, start_at, video, exercices})
             .then(({id}) => finish(1, id), () => finish(2));
    },
  },
  created() {
    Produit.List().then(res => {
      this.options = res
          .sort(
              function (a, b) {
                return a.contenu.toLowerCase().localeCompare(b.contenu.toLowerCase());
              }
          )
          .map(({id, contenu}) => {
            return {text: contenu, value: id}
          });
    })
    const {id} = this.$route.params
    if (id === "new") return;
    this.id = id;
    Produit.GetContenuPrincipal(id).then(({titre, start_at, video, exercices}) => {
      this.titre = titre;
      this.start_at = start_at.slice(0, 10);
      this.video = video;
      this.exercices = exercices;
    })
  }
}
</script>

<style scoped>

</style>